import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(form) {
    return baseApi.post('api-article/individual-report-result/v1', form);
  },
  delete(reportId) {
    return baseApi.delete(`api-article/individual-report-result/v1/${reportId}`);
  },
  fetch(resultId) {
    return baseApi.get(`api-article/individual-report-result/v1/${resultId}`);
  },
  syncSortOrders(sortOrders) {
    return baseApi.post(`api-article/individual-report-result/v1/sync-sort-orders`, sortOrders);
  }
}
